var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4915 0.666626H5.50817C2.47484 0.666626 0.666504 2.47496 0.666504 5.50829V12.4916C0.666504 13.4 0.824837 14.1916 1.13317 14.8583C1.84984 16.4416 3.38317 17.3333 5.50817 17.3333H12.4915C15.5248 17.3333 17.3332 15.525 17.3332 12.4916V10.5833V5.50829C17.3332 2.47496 15.5248 0.666626 12.4915 0.666626ZM15.9748 9.41663C15.3248 8.85829 14.2748 8.85829 13.6248 9.41663L10.1582 12.3916C9.50817 12.95 8.45817 12.95 7.80817 12.3916L7.52484 12.1583C6.93317 11.6416 5.9915 11.5916 5.32484 12.0416L2.20817 14.1333C2.02484 13.6666 1.9165 13.125 1.9165 12.4916V5.50829C1.9165 3.15829 3.15817 1.91663 5.50817 1.91663H12.4915C14.8415 1.91663 16.0832 3.15829 16.0832 5.50829V9.50829L15.9748 9.41663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.173d07a5efad60157cf8d18daa832a1b.svg";
export { ForwardRef as ReactComponent };